import styled from "styled-components"
import FadeIn from "react-fade-in"

const ContainerLight = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const StyledFade = styled(FadeIn)`
  & > div:nth-of-type(1),
  & > div:nth-of-type(3) {
    background-color: ${(props) => props.theme.a_color_gradients.a_light};
  }
`

export { ContainerLight, StyledFade }
